export default "__VITE_ASSET__90502528__"